import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export const useQueryValues = (
  params: string[],
): {
  [key: string]: string;
} => {
  const query = useQuery();

  return params
    .map((key) => [key, query.get(key)] as [string, string | null])
    .reduce((prev, curr) => (curr[1] ? { ...prev, [curr[0]]: curr[1] } : prev), {});
};

export const useParamValues = (
  params: string[],
): {
  [key: string]: string;
} => {
  const values = useParams();

  return params
    .map((key) => [key, values[key]] as [string, string | null])
    .reduce((prev, curr) => (curr[1] ? { ...prev, [curr[0]]: curr[1] } : prev), {});
};
